var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"","visible":_vm.loginShow,"width":"30%","center":"","close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.loginShow=$event},"close":_vm.loginClose}},[_c('iframe',{attrs:{"src":_vm.codeUrl,"frameborder":"0","width":"100%","height":"400","id":"preview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }